import React from "react";
import styles from "./ParallelCard.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useMusic } from "../../../context/MusicContext";

/** REUSEABLE COMPOENENTS */
import CategoryTitle from "../../reusable/categoryTitle/CategoryTitle";
import CategorySeeAllButton from "../../reusable/categorySeeAll/CategorySeeAll";

const ParallelCard = ({
  data,
  title,
  category_id = null,
  category_type = null,
}) => {
  const musicContext = useMusic();
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/music/detail/${category_type}/${id}`, { state: { type: "one", normal : true } });
  };

  return (
    <div className={`w-full`}>
        <div className="my-4 flex justify-center">
          <CategoryTitle title={title} />
          {category_id && category_type && (
            <CategorySeeAllButton to={`/music/see_all/${category_id}/${category_type}`} />
            // <Link
            //   to={`/music/see_all/${category_id}/${category_type}`}
            //   className="float-right text-yellow-400"
            // >
            //   See All
            // </Link>
           )}
        </div>
     
      <div className={`grid grid-cols-2 gap-4`}>
        {data.map((data, index) => (
          <div
            key={index}
            className="flex"
            onClick={() => handleClick(data.id)}
          >
            <div className="w-2/5 inline-block">
              <img
                src={data.image}
                alt={`Image ${index + 1}`}
                className={`rounded-lg`}
                style={{ textShadow: "2px 2px 4px #000000" }}
              />
            </div>
            <div className="w-2/5 flex items-center justify-center">
              <div className="w-full ml-4">
                {
                  data.title && (
                    <span className="block text-sm truncate pb-1">{data.title}</span>
                  )
                }
                {
                  data.desc && (
                    <span className="block text-xs py-1 truncate">{data.desc}</span>
                  )
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParallelCard;
